<app-side-color-card color="primary-1">
  <div content class="card">
    <h4>Detalhes da Posição</h4>
    <section class="container">
      <div class="position">
        <app-info-oc-or-nfe label="RfId do chão" [value]="position?.rfid || '---'"></app-info-oc-or-nfe>
        <app-info-oc-or-nfe label="Coordenadas" [value]="formatCoords()"></app-info-oc-or-nfe>
        <app-info-oc-or-nfe label="Apelido" [value]="position?.alias || '---'"></app-info-oc-or-nfe>
      </div>
      <div class="group">
        <app-info-oc-or-nfe label="tipo do chão" [value]="position?.type || '---'"></app-info-oc-or-nfe>
        <app-info-oc-or-nfe label="grupo" [value]="position?.group?.name || '---'"></app-info-oc-or-nfe>
        <app-info-oc-or-nfe label="tipo do grupo" [value]="position?.group?.type || '---'"></app-info-oc-or-nfe>
      </div>
    </section>
    <div class="buttons">
      <button mat-stroked-button class="alert" (click)="onRemovePosition()">
        Excluir Posição
      </button>
      <button mat-raised-button class="primary-1" (click)="openInventorySidenav()">
        inventariar
      </button>
    </div>
  </div>
</app-side-color-card>

<ng-template #notification>
  <app-notification [data]="notificationData" icon="check-circle"></app-notification>
</ng-template>
